<template>
  <div class="tabscontens">
    <template>
      <el-tabs tab-position="left" style="height: 100%">
        <el-tab-pane
          v-for="(item, index) in contentsList"
          :label="item.title"
          :key="index"
        >
          <div class="title">
            <span class="line left"><img src="./jpg/goldLeft.png" alt=""/></span>
            <h3 class="contentTitle">{{ item.title }}</h3>
            <span class="line right"><img src="./jpg/goldRight.png" alt=""/></span>
          </div>
          <p v-for="item2 in item.contentData" :key="item2">{{ item2 }}</p>
          <p class="floatRight" v-for="item3 in item.rightInfo" :key="item3">
            {{ item3 }}
          </p>
        </el-tab-pane>
      </el-tabs>
    </template>
  </div>
</template>
<script>
export default {
  name: "dwgwggtabs",
  props: [],
  computed: {},
  data() {
    return {
      index: 0,
      contentsList: [
        {
          title: "严正声明",
          rightInfo: ["浙江蝶威资产管理有限公司", "2021-11-2"],
          contentData: [
            "浙江蝶威资产管理有限公司（下称“我司”）是一家在中国证券投资基金业协会备案的私募证券投资基金管理人（登记编码：P1070101），自公司创立以来便专注于为各类合格投资者提供专业投资管理服务。",
            "近日，我司接到关于冒用我司名称和我司基金经理魏铭三，通过QQ群推荐股票、诈骗的举报。",
            "为维护我司及投资者们的合法权益，避免不良影响持续发酵，特发表声明如下：",
            "一、我司严格按照《证券投资基金法》、《私募投资基金监督管理暂行办法》等法律法规以及行业自律规则进行基金产品的募集、管理和运营，对基金产品的募集恪尽特定对象确定、投资者适当性审查、私募基金推介及合格投资者确认等相关责任。",
            "二、我司在基金产品的运营及管理中，不存在以下行为：",
            "（1）公开推介或者变相公开推介；",
            "（2）推介材料虚假记载、误导性陈述或者重大遗漏；",
            "（3）以任何方式承诺投资者资金不受损失，或者以任何方式承诺投资者最低收益；",
            "（4）夸大或者片面推介基金，违规使用“安全”、“保证”、“承诺”、“保险”、“避险”、“有保障”、“高收益”、“无风险”等可能误导投资人进行风险判断的措辞；",
            "（5）允许非本机构雇佣的人员进行私募基金推介；",
            "（6）推介非本机构设立或负责募集的私募基金；",
            "（7）法律、行政法规、中国证监会和中国基金业协会禁止的其他行为。",
            "在此郑重提醒投资者，任何形式的公开募集行为均非我司行为，谨防上当受骗。",
            "三、我司无分公司、子公司等分支机构，且从未授权除我司员工以外的任何个人和机构以我司名义进行任何与投资管理相关的业务活动。任何以我司或我司员工名义推荐股票或其他金融产品的不法行为与我司无关，我司对此不承担任何法律责任。",
            "四、我司对冒用行为予以强烈谴责，并将收集到的情况如实报送相关机构，同时，保留进一步追究相关人士法律责任的权利。",
            "五、任何个人或机构如发现上述情况，请通过微信公众号后台留言、发送邮件至info@deepwin.ai或拨打021-58881360进行核实、举报。",
            "最后，我司提醒广大投资者谨慎对待此类信息及电话，提高警惕、谨防受骗。",
            "特此公告！",
          ],
        },{
          title: "重大变更公告",
          rightInfo: ["浙江蝶威资产管理有限公司", "2020-9-28"],
          contentData: [
            "根据公司发展情况需要，于2020年9月11日召开股东会决议，任命魏铭三为公司新法定代表人、执行董事，原法定代表人、执行董事费革胜改任投资决策委员会主席。现公司已完成工商变更，已于2020年9月17日生效。",
            "特此公告！",
          ],
        },{
          title: "关于公司更名的公告",
          rightInfo: ["上海蝶威私募基金管理有限公司", "2023-12-20"],
          contentData: [
            "尊敬的各位合作伙伴、客户:",
            "浙江蝶威资产管理有限公司正式更名为上海蝶威私募基金管理有限公司,注册地址由浙江省宁波市鄞州区首南西路88、76号B幢1层707室变更为中国(上海)自由贸易试验区临港新片区新四平公路468弄14幢17号，办公地址仍为上海市浦东新区世纪大道1777号东方希望大厦6层E室。此次变更后，公司注册地和办公地均为上海市。",
            "除公司名称和法定注册地址的更改外，公司办公地址、联系方式以及组织架构等均保持不变。作为一家专注于私募基金管理的公司，我们将继续为客户提供专业、全面的资产管理服务，助力他们实现财富增值和长期投资目标。",
            "我们诚挚地感谢您一直以来对我们公司的支持和信任。如有任何疑问或需要进一步了解更多信息，请随时与我们联系。感谢您的关注和支持。",
          ],
        }
      ],
    };
  },
  methods: {},
};
</script>

<style scoped>
.tabscontens {
  background-color: #fff;
  position: relative;
  box-shadow: 0 0 8px 4px rgba(92, 77, 36, 0.08);
  text-align: center;
  width: 750px;
  margin: auto;
  margin-top: -100px;
  min-height: 400px;
  padding: 40px 100px;
}
p {
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  margin: 0 0 10px;
  color: #666;
  font-size: 14px;
  line-height: 32px;
  text-indent: 32px;
  text-align: justify;
}
.floatRight {
  text-align: right;
}
.title {
  height: 100px;
  line-height: 100px;
}

.contentTitle {
  display: inline-block;
  font-size: 30px;
  color: #555;
  text-align: center;
  margin: 0 50px;
  font-weight: inherit;
}

.line > img {
  vertical-align: middle;
  padding-bottom: 10px;
  width: 75px;
}
</style>



// WEBPACK FOOTER //
// src/components/dwgwggtabs.vue